<script>
    import { fade } from 'svelte/transition';
    import FVHero from '../components/FVHero.svelte'
    import Centering from '../layouts/Centering.svelte'
    import Article from '../widgets/Article.svelte'
    import FillButton from '../components/FillButton.svelte'
    import Heading from '../components/Heading.svelte'
    const src = {
        pc:"img/recruit-fv.png",
        mb:"img/recruit-fv_mb.png"
    }
    const content = `
    <h3>1.ドライバー職</h3>
        <p>応募資格</p>
        <p>普通自動車免許/高校新卒歓迎/既卒・第二新卒歓迎/副業・WワークOK/未経験OK</p>
        <p>&nbsp;</p>
        <p>勤務地</p>
        <p>・(株)有倉商店本社</p>
        <p>東京都江東区亀戸5-33-5</p>
        <p>TEL03-3684-1875</p>
        <p>・(株)有倉商店市川支社</p>
        <p>千葉県市川市鬼高 4-5-1(市川市地方卸売市場)</p>
        <p>TEL047-370-0831</p>
        <p>&nbsp;</p>
        <p>仕事内容</p>
        <p>首都圏の小中学校、病院、などをメインに納品しており、公共のお客様が中心となります。納品時は、お客様に対面で対応する為、有倉商店の「顔」になる仕事です。配送時間自体は、2~5時間位ですが、会社に戻ってから翌日の選果作業に入れますので、青果の知識が身につき、その知識を活かしてお客様との信頼関係を築いていく楽しさがあります。そして、急成長中の職場ですのでやる気がある方は管理職を目指せる可能性もあります。</p>
        <p>&nbsp;</p>
        <h3>2.選果作業職</h3>
        <p>応募資格</p>
        <p>高校新卒歓迎/既卒・第二新卒歓迎/副業・WワークOK/未経験OK</p>
        <p>&nbsp;</p>
        <p>勤務地</p>
        <p>・(株)有倉商店本社</p>
        <p>東京都江東区亀戸5-33-5</p>
        <p>TEL03-3684-1875</p>
        <p>・(株)有倉商店市川支社</p>
        <p>千葉県市川市鬼高4-5-1(市川市地方卸売市場)</p>
        <p>TEL047-370-0831</p>
        <p>&nbsp;</p>
        <p>仕事内容</p>
        <p>野菜全般・下処理野菜・果物に分かれており、選果作業(全ての商品の良し悪しを判断して、品物を用意します)がメインの仕事となります。有倉商店は、青果の選果力に長けたメンバーに恵まれており、また野菜&果物に直接触れますので、深い知識が身につきます。 有倉商店では、八百屋としては早くから「衛生管理」に取り組んでおりHACCPの考え方を取り入れた衛生管理の取組を行っています。 </p>
        <img src="img/ri_pic1.png">`
</script>
<svelte:head>
	<title>採用情報 | 株式会社有倉商店</title>
</svelte:head>
<div transition:fade>
    <FVHero images={src} />
    <div class="mt"></div>
    <Centering>
        <Heading
            text={{
                main:"RECRUIT",
                sub:"採用情報"
            }}
        />
    </Centering>
    <Article
        title="求人募集のお知らせ"
        date="2021.03.01"
        content={content}
    />
    <Centering>
        <div class="btn-layout">
            <FillButton 
            href="/contact/?type=recruit"
            style={{
                width:325,
                height:60,
                borderWidth:2,
                color:"#FF9B11",
                base:"#F5F5F5"
            }}
            text="採用に関するお問い合わせ"
        />
        </div>
    </Centering>
</div>


<style>
    .mt {
        margin-top: 75px;
    }
    .btn-layout{
        margin-top: 50px;
        position: relative;
        margin-left: auto;
        margin-bottom: 125px;
    }
    @media screen and (max-width:640px){
        .btn-layout{
            width: 100%;
            margin: 0 auto;
            margin-top: 35px;
            margin-bottom: 125px;
        }
    }
</style>
